import { Link } from 'react-router';

import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import belowMinimumImage from 'images/BelowMinimumBox.svg';
import belowMinimumTempoImage from 'images/BelowMinimumBoxTempo.svg';
import style from 'styles/shared/dashboardMealCardRedesign';

const BelowMinimumCardRedesign = ({ actionLink = '', cardStyle = style.mealCard }) => {
  const isTempo = useBrand(TEMPO);
  const minimumMealCount = isTempo ? 4 : 2;
  const belowMinimumCardImage = isTempo ? belowMinimumTempoImage : belowMinimumImage;
  const backgroundClass = isTempo ? 'bg-tempo-gray-40' : 'bg-cream-100';

  return (
    <article>
      {actionLink ? (
        <Link to={actionLink}>
          <div className={`flex items-center justify-between rounded-lg ${backgroundClass} p-6`}>
            <div className="flex flex-col gap-2">
              <h1 className="h5 bp2:h4 text-charcoal-100">Your order is a little light!</h1>
              <span className="textSm bp2:text text-charcoal-100">
                Choose at least {minimumMealCount} meals to receive{' '}
                <br className="hidden bp2:block" /> this order.
              </span>
            </div>
            <img
              alt="Below Minimum Empty Box"
              src={belowMinimumCardImage}
              className="h-16 w-16 flex-shrink-0 pl-4 bp2:h-[90px] bp2:w-[90px]"
            />
          </div>
        </Link>
      ) : (
        <>
          <img width="100%" alt="Below Minimum Empty Plate" src={belowMinimumImage} />
          <div className={cardStyle}>
            <div className={style.body}>
              <div className={style.main}>
                <h1 className="h6 pb-4">You Are Below the Minimum for Delivery</h1>
              </div>
            </div>
          </div>
        </>
      )}
    </article>
  );
};

BelowMinimumCardRedesign.propTypes = {
  actionLink: PropTypes.string.isRequired,
  cardStyle: PropTypes.string,
};

export default BelowMinimumCardRedesign;
